module.exports = __webpack_public_path__ + "img/dj.2863d6e2.jpg";